import "./TranslationKeys.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import TranslationKeysComponentController from "./TranslationKeysComponentController";

export class TranslationKeysComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {};
        this.controller = TranslationKeysComponentController;
        this.templateUrl = "/App/Components/TranslationKeys/TranslationKeys.html";
    }
}

module("mmManagePortal").component("mmTranslationKeys", new TranslationKeysComponent());
